module.exports = __webpack_public_path__ + "static/0-ee1b61ae645d66c874482332f25c5e54.jpg";